import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { Role } from "../gen/rbt/cloud/v1alpha1/organization/organization_pb";

// This functions is given a short and surprising name by convention. It is
// also a dependency of some of the components in 'components/ui.'
// When using formatting libraries like `classnames` or `clsx`, it is common to
// wrap these calls and shorten them to `cn` because it is a utility that is
// used so frequently.
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Get the display label for a role.
 */
export function getRoleLabel(role: Role): string {
  switch (role) {
    case Role.OWNER:
      return "Owner";
    case Role.EDITOR:
      return "Editor";
    case Role.VIEWER:
      return "Viewer";
    default:
      return "Unknown";
  }
}

/**
 * Get the lowercase string representation of a role.
 */
export function getRoleString(role: Role): string {
  return getRoleLabel(role).toLowerCase();
}

/**
 * Get the badge variant for a role.
 */
export function getRoleBadgeVariant(
  role: Role
): "default" | "secondary" | "outline" {
  switch (role) {
    case Role.OWNER:
      return "default";
    case Role.EDITOR:
      return "secondary";
    case Role.VIEWER:
      return "outline";
    default:
      return "outline";
  }
}
